export default async function loadLatestTweet($element) {
    try {
        const data = await getTweetContent();
        $element.html(data.content);
        $element.removeClass('loading');
    } catch (e) {
        console.warn(e);
        $element.removeClass('loading');
    }
}

async function getTweetContent() {
    return Ajax.get('eotw', 'tweets');
}
